// A focus request's turn on one render (useFocusRequest, the full-page
// checkout's focus). Pure: the hook keeps the request as state and runs
// this from its effect.

export type FocusTurn = "none" | "done" | "wait" | "fallback";

/**
 * What a render does with the focus request it shows:
 *   none      no request, or this one was acted on already (each request
 *             once — its sequence number `n`, against `done`);
 *   done      its target was there: `aim()` moved the focus (or found
 *             nothing that needed doing);
 *   wait      its target is not there yet: one more render;
 *   fallback  still not there on that render (`waited` is this request):
 *             the fallback takes the focus, never the page behind.
 * `aim` runs only for a request not acted on yet.
 */
export function focusRequestTurn(
  request: { readonly n: number } | null,
  done: number,
  waited: number,
  aim: () => boolean,
): FocusTurn {
  if (!request || request.n === done) return "none";
  if (aim()) return "done";
  return waited === request.n ? "fallback" : "wait";
}
